import { render, staticRenderFns } from "./ModalProjectAddPerson.vue?vue&type=template&id=55899d24&scoped=true"
import script from "./ModalProjectAddPerson.vue?vue&type=script&lang=js"
export * from "./ModalProjectAddPerson.vue?vue&type=script&lang=js"
import style0 from "./ModalProjectAddPerson.vue?vue&type=style&index=0&id=55899d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55899d24",
  null
  
)

export default component.exports